
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Website } from '@/services/Website/interfaces';
import { CertificateInterface } from '@/services/SSL/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: { StatusChip },
})
export default class WebsiteSslResult extends Vue {
  @Prop({ type: Object, required: true })
  public website!: Website;

  @Prop({ type: Object, required: true })
  public certificate!: CertificateInterface;
}
